import { Ref } from '@nuxtjs/composition-api';

const useSteppers = (groupInner: Ref<HTMLElement>) => {
  const onLeftStep = () => {
    if (groupInner.value) {
      groupInner.value.scrollLeft = groupInner.value.scrollLeft - groupInner.value.clientWidth;
    }
  };

  const onRightStep = () => {
    if (groupInner.value) {
      groupInner.value.scrollLeft = groupInner.value.scrollLeft + groupInner.value.clientWidth;
    }
  };

  return {
    onLeftStep,
    onRightStep,
  };
};

export default useSteppers;
